import { setCookie } from 'nookies';
import { validCurrencies } from "../constants/currencies";
import { getCountry } from "./countries";
export var CURRENCY_COOKIE = 'currency';
export var COUNTRY_CODE_COOKIE = 'country_code';
export var COUNTRY_NAME_COOKIE = 'country_name';
export var DELIVERY_ZONE_COOKIE = 'delivery_zone';
export var FORCE_CURRENCY_QUERY_PARAM = 'force_currency';
export var DEFAULT_LOCALE = getCountry('GB');
var getLocale = function getLocale(_ref) {
  var cookies = _ref.cookies;
  var _ref2 = cookies || {},
    countryCode = _ref2[COUNTRY_CODE_COOKIE],
    countryName = _ref2[COUNTRY_NAME_COOKIE],
    _ref2$CURRENCY_COOKIE = _ref2[CURRENCY_COOKIE],
    currencyCode = _ref2$CURRENCY_COOKIE === void 0 ? '' : _ref2$CURRENCY_COOKIE,
    deliveryZone = _ref2[DELIVERY_ZONE_COOKIE];
  var currency = validCurrencies.includes(currencyCode) ? currencyCode : undefined;
  return {
    currency,
    countryCode,
    deliveryZone,
    countryName
  };
};
var hasLocaleSet = function hasLocaleSet(req) {
  var _getLocale = getLocale(req),
    countryCode = _getLocale.countryCode,
    countryName = _getLocale.countryName,
    currency = _getLocale.currency,
    deliveryZone = _getLocale.deliveryZone;
  return Boolean(currency && countryCode && deliveryZone && countryName);
};
var getLocaleCookieOptions = function getLocaleCookieOptions() {
  var aYearFromNow = new Date();
  aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 1);
  return {
    expires: aYearFromNow,
    path: '/'
  };
};
var setLocale = function setLocale(country, res) {
  var cookieOptions = getLocaleCookieOptions();
  setCookie({
    res
  }, CURRENCY_COOKIE, country === null || country === void 0 ? void 0 : country.currency, cookieOptions);
  setCookie({
    res
  }, COUNTRY_CODE_COOKIE, country === null || country === void 0 ? void 0 : country.countryCode, cookieOptions);
  setCookie({
    res
  }, COUNTRY_NAME_COOKIE, country === null || country === void 0 ? void 0 : country.name, cookieOptions);
  setCookie({
    res
  }, DELIVERY_ZONE_COOKIE, country === null || country === void 0 ? void 0 : country.deliveryZoneCode, cookieOptions);
};
export var sanitiseForceCurrencyParam = function sanitiseForceCurrencyParam() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var userSetCurrency = arguments.length > 1 ? arguments[1] : undefined;
  var forceCurrencyParam = query[FORCE_CURRENCY_QUERY_PARAM];
  if (forceCurrencyParam) {
    var currency = (Array.isArray(forceCurrencyParam) ? forceCurrencyParam[0] : forceCurrencyParam).toUpperCase();
    var isValidCurrencyCode = validCurrencies.includes(currency);
    if (isValidCurrencyCode) {
      return currency;
    }
  }
  if (userSetCurrency && userSetCurrency !== DEFAULT_LOCALE.currency) {
    return userSetCurrency;
  }
  return null;
};
export var setLocaleCookies = function setLocaleCookies(_ref3) {
  var _ref3$query = _ref3.query,
    query = _ref3$query === void 0 ? {} : _ref3$query,
    req = _ref3.req,
    res = _ref3.res;
  var hasLocaleSetByUser = hasLocaleSet(req);
  if (!hasLocaleSetByUser) {
    setLocale(DEFAULT_LOCALE, res);
  }
  var userSetLocaleCurrency = getLocale(req).currency;
  var forceCurrencyParam = sanitiseForceCurrencyParam(query, userSetLocaleCurrency);
  if (forceCurrencyParam) {
    setCookie({
      res
    }, CURRENCY_COOKIE, forceCurrencyParam, getLocaleCookieOptions());
  }
};